var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownloadAction = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M9.169 10.063c-.002-.02-.003-.042-.003-.063V3.333c0-.46.373-.833.834-.833.46 0 .833.373.833.833V10l2-1.5c.368-.277.89-.202 1.167.167.276.368.201.89-.167 1.166l-3.333 2.5c-.148.111-.325.167-.5.167-.168 0-.335-.05-.48-.152l-3.333-2.345c-.376-.265-.467-.785-.202-1.16.265-.377.784-.468 1.16-.203l2.024 1.423zm-4.17 4.104V15h10v-.833c0-.459.376-.834.834-.834.458 0 .833.375.833.834v1.666c0 .459-.375.834-.833.834H4.166c-.458 0-.833-.375-.833-.834v-1.666c0-.459.375-.834.833-.834.459 0 .834.375.834.834z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadAction, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download_action.6ab8f580.svg";
export { ForwardRef as ReactComponent };